import React from 'react';
import { CompassIcon, LayersIcon, MessageSquareQuoteIcon, MusicIcon, SparklesIcon, UsersIcon } from 'lucide-react';
import { volumes, type VolumeIcon } from '../data/volumes';
import { Eyebrow } from './Eyebrow';
const icons: Record<VolumeIcon, React.ElementType> = {
  method: CompassIcon,
  rhythm: MusicIcon,
  harmony: LayersIcon,
  language: MessageSquareQuoteIcon,
  improv: SparklesIcon,
  jam: UsersIcon
};
export function Volumes() {
  return <section aria-labelledby="volumes-heading" className="bg-paper-100 py-16 sm:py-24" data-id="element-286" data-mp="1zt8grwaywnfh">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-287" data-mp="24s1r5fuyjybf">
        <div className="max-w-2xl" data-id="element-288" data-mp="1qtblvcxzisbz">
          <Eyebrow data-id="element-289" data-mp="1qwhays6m5u7p">The complete system: 6 volumes</Eyebrow>
          <h2 id="volumes-heading" className="mt-4 font-display text-3xl font-semibold leading-tight text-ink sm:text-5xl" data-id="element-290" data-mp="1vseqwxdysyjy">
            Six volumes
          </h2>
        </div>

        <ol className="mt-8 grid gap-5 sm:mt-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-291" data-mp="kf2hm6zfrnqe">
          {volumes.map(volume => {
          const Icon = icons[volume.icon];
          return <li key={volume.number} className="flex flex-col border border-paper-300 bg-paper p-6 sm:p-7" data-id="element-292" data-mp="3ja53br701sx4">
                <div className="flex items-center gap-4" data-id="element-293" data-mp="3t79gj1ivae1s">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center" style={{
                backgroundColor: volume.accent
              }} data-id="element-294" data-mp="3t5on5f8ah15i">
                    <Icon className="h-5 w-5 text-paper" aria-hidden="true" data-id="element-295" data-mp="61sbyn5d80ey" />
                  </span>
                  <span className="text-[11px] font-semibold uppercase tracking-label text-brass-dark" data-id="element-296" data-mp="kq504xy7oeyw">
                    Vol. {volume.number}
                  </span>
                </div>

                <h3 className="mt-6 font-display text-xl font-semibold leading-snug text-ink sm:text-2xl" data-id="element-297" data-mp="tsxq8xvnqkn5">
                  {volume.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-ink-soft" data-id="element-298" data-mp="wtzg6r83uaag">{volume.description}</p>

                <p className="mt-auto pt-6 text-xs font-semibold leading-relaxed text-ink" data-id="element-299" data-mp="11skicw6x341j">
                  {volume.contents.join(' · ')}
                </p>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}